module.exports = __webpack_public_path__ + "img/banner.ea54759a.jpg";